import {
  initializeWidgetConfiguration,
  SgWidget,
  WidgetConfigurationProvider,
  WithGlobalCss,
} from "@sgwt-widget/core";
import { h } from "preact";
import { props } from "skatejs";
import WidgetTracker from "../common/components/WidgetTracker/WidgetTracker";
import { IClientAccount } from "../common/utils/types";
import { SalescreditClientList } from "./components/SalescreditClientList";
import {
  AgGridUserPreference,
  UserSelection,
} from "../common/sg-dashboard/userPreference/userPreference.typings";
import { saveUserPreferences } from "../common/sg-dashboard/userPreference/userpreference";
import { events } from "../common/sg-dashboard/userPreference/event";
import { MapToAgGridUserPreference } from "../common/sg-dashboard/userPreference/userpreference.map";
import { ObsoleteWidgetMessage } from "../common/utils/ObsoleteWidgetMessage";

interface IProps {
  filters?: { [attribute: string]: string[] | string | IClientAccount[] };
  userSelection: UserSelection;
  userEmail?: string;
}

class CprSalescreditClient extends SgWidget<IProps> {
  public static is = "cpr-salescredit-client-list";

  public static props = {
    filters: props.object,
    userEmial: props.string,
    userSelection: props.object,
  };

  public render(intraprops: IProps) {
    const headers = { uiscreen: (this.constructor as any).is };

    const onColumnsMoved = (value: AgGridUserPreference) => {
      intraprops.userSelection = value;
      saveUserPreferences(this, [events.Sc_Client_List], value);
    };

    return (
      <WidgetConfigurationProvider
        widgetConfiguration={this.widgetConfiguration}
      >
        <WithGlobalCss>
          <ObsoleteWidgetMessage newWidgetId={2440} />
          <SalescreditClientList
            filters={this.props.filters}
            headers={headers}
            onColumnsMoved={onColumnsMoved}
            userSelection={MapToAgGridUserPreference(intraprops.userSelection)}
          />
          <WidgetTracker widgetName={CprSalescreditClient.is} />
        </WithGlobalCss>
      </WidgetConfigurationProvider>
    );
  }
}
initializeWidgetConfiguration(CprSalescreditClient);
customElements.define(CprSalescreditClient.is, CprSalescreditClient);
